import React, { useState, useEffect, useRef, useContext } from'react'
import TransitionLink from 'gatsby-plugin-transition-link'
import gsap from 'gsap'
import styled from 'styled-components'

import data from './../data/en_new.json'
import { SavedTripsContext } from '../utils/savedTripsContext'
import activities from '../data/activities'
import {
  EventView,
  EventWrapper,
  EventName,
  Location,
  GhostButton
} from './'

const MobileMenuView = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  padding: 10vh 1rem 0;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  z-index: 400;
  overflow: hidden;
`

const Background = styled.div`
  width: 0;
  height: 0;
  top: 0;
  right: 0;
  position: fixed;
  background-color: #041E42;
  z-index: 300;
`

const LearnMoreHolder = styled.div`
  margin: 1rem auto 2rem;
  font-size: 1rem;
  font-family: 'Sica', sans-serif;
`

const SvgHolder = styled.div`
  display: inline-block;
  margin-left: .8rem;
  vertical-align: middle;
`

const TextHolder = styled.div`
  display: flex;
  align-items: center;
`

const MenuElement = styled.div`
  display: flex;
  font-size: 2rem;
  color: #ffffff;
  line-height: 1;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  margin-bottom: 10vh;
  max-height: 12vh;
  font-weight: 700;

  span {
    margin-right: 20px;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`


const LinkSvgHolder = styled(SvgHolder)`
  svg {
    width: 22px;
    height: auto;
  }
`

const ArrowHolder = styled.div`
  transform: ${({isOpen}) => isOpen ? 'rotate(-45deg)': 'rotate(135deg)'};
  transition: transform .35s ease-in-out;
`

const SavedEventView = ({ id, title }) => {
  return <EventWrapper>
  <EventName>{id}</EventName>
  <Location>{title}</Location>
</EventWrapper>
}

const ArrowSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14.981" height="14.981" viewBox="0 0 14.981 14.981">
    <g transform="translate(-1263.186 -14.5)">
      <path id="Path_986" data-name="Path 986" d="M390-215h14.127v14.127" transform="translate(873.539 230)" fill="none" stroke='#ffffff'strokeMiterlimit="10" strokeWidth="1"/>
    </g>
  </svg>
)

const MobileArrow = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='21.186' height='20.686'>
    <g fill='none' stroke='#fff' strokeMiterlimit='10'>
      <path data-name='Path 986' d='M10.49.354l9.989 9.989-9.99 9.99'/>
      <path data-name='Line 12' d='M20.062 10.343H.5'/>
    </g>
  </svg>
)

const EventsContainer = styled.div`
  max-height: 0vh;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
    color: #00000000;
  }
`

const MobileMenu = ({ isOpen, close }) => {
  const bgRef = useRef()
  const eventsRef = useRef()
  const mainRef = useRef()
  const infoRef = useRef()
  const signupRef = useRef()
  const savedRef = useRef()
  const savedEventsRef = useRef()

  const [isFullProgramOpen, setIsFullProgramOpen] = useState(false)
  const [isSavedEventsOpen, setSavedEventsOpen] = useState(false)
  const { savedTrips, setSavedTrips } = useContext(SavedTripsContext)

  useEffect(() => {
    if(isOpen && bgRef.current) {
      gsap.set('.mobile-menu', {
        width: '100vw',
        height: '100vh',
      })

      gsap.to(bgRef.current, { width: '100%', height: '100vh', duration: .3 })
      gsap.to('.mobile-menu', {
        opacity: 1,
        duration: .5,
        delay: .2,
      })
    }

    if(!isOpen && bgRef.current) {
      gsap.to(bgRef.current, { width: 0, height: 0, duration: .3 })
      gsap.to('.mobile-menu', {
        opacity: 0,
        duration: .5,
        onComplete: () => {
          gsap.set('.mobile-menu', {
            width: 0,
            height: 0,
          })
          gsap.set([mainRef.current, savedRef.current, signupRef.current, infoRef.current], {
            maxHeight: '12vh',
            marginBottom: '3rem'
          })
          gsap.set([savedEventsRef.current, eventsRef.current], {
            maxHeight: '0',
          })
        }
      })
    }

  }, [isOpen])

  useEffect(() => {
    const tl = gsap.timeline()

    if(isFullProgramOpen) {
      tl
      .to([savedRef.current, signupRef.current, infoRef.current],
        {
          maxHeight: '0vh',
          duration: 1.3,
          marginBottom: '0rem'
        }
      )
      .to([mainRef.current, eventsRef.current], {
        maxHeight: '90vh',
        duration: 1.8,
      }, 0)
    } else {
      tl
      .to([savedRef.current, signupRef.current, infoRef.current, mainRef.current],
        {
          maxHeight: '12vh',
          duration: 1.3,
          marginBottom: '3rem'
        }
      )
      .to(eventsRef.current, {
        maxHeight: '0vh',
        duration: 1.3,
      }, 0)
    }
  }, [isFullProgramOpen])


  useEffect(() => {
    const tl = gsap.timeline()

    if(isSavedEventsOpen) {
      tl
      .to([mainRef.current, signupRef.current, infoRef.current],
        {
          maxHeight: '0vh',
          duration: 1.3,
          marginBottom: '0rem'
        }
      )
      .to([savedRef.current, savedEventsRef.current], {
        maxHeight: '90vh',
        duration: 1.8,
      }, 0)
    } else {
      tl
      .to([savedRef.current, signupRef.current, infoRef.current, mainRef.current],
        {
          maxHeight: '12vh',
          duration: 1.3,
          marginBottom: '3rem'
        }
      )
      .to(savedEventsRef.current, {
        maxHeight: '0vh',
        duration: 1.3,
      }, 0)
    }
  }, [ isSavedEventsOpen ])

  const removeActivty = (id) => {
    setSavedTrips(savedTrips.filter(trip => trip !== id))
  }

  return (
    <>
      <MobileMenuView className='mobile-menu' isOpen={isOpen}>
        <MenuElement ref={mainRef}>
            <TextHolder onClick={() => setIsFullProgramOpen(!isFullProgramOpen)}>
              <span>PROGRAM OVERVIEW</span>
              <ArrowHolder isOpen={isFullProgramOpen}>
                <ArrowSvg />
              </ArrowHolder>
           </TextHolder>
          <EventsContainer ref={eventsRef}>
            {data.events.map((event, i) => (
              <EventView key={`${event.event}-${i}`} {...event}/>
            ))}
            
            <TransitionLink
              to='/signup'
              exit={{
                trigger: ({ entry, node }) => gsap.to(node, { xPercent: -100, duration: .4, ease: 'power3.out', }),
                length: .3
              }}
              entry={{
                trigger: ({ exit, node }) => gsap.from(node, { xPercent: 100, duration: .4, ease: 'power3.out', }),
                length: .3
              }}
            >
              <GhostButton>
                Click here to attend
              </GhostButton>
            </TransitionLink>
            <LearnMoreHolder >
              <TransitionLink
                to='/petur-larsen'
                style={{ color: '#ffffff' }}
                exit={{
                  trigger: ({ entry, node }) => gsap.to(node, { opacity: 0, duration: .3 }),
                  length: .3
                }}
                entry={{
                  trigger: ({ exit, node }) => gsap.from(node, { opacity: 0, duration: .3 }),
                  delay: .3,
                  length: .3
                }}
              >
                Learn more about the events and what<br/>
                <span>else to explore here</span>
                <LinkSvgHolder>
                  <MobileArrow />
                </LinkSvgHolder>
              </TransitionLink>
            </LearnMoreHolder>

          </EventsContainer>
        </MenuElement>
        <MenuElement ref={infoRef}>
        <TransitionLink
              to='/information'
              style={{ color: '#ffffff' }}
              exit={{
                trigger: ({ entry, node }) => gsap.to(node, { opacity: 0, duration: .3 }),
                length: .3
              }}
              entry={{
                trigger: ({ exit, node }) => gsap.from(node, { opacity: 0, duration: .3 }),
                delay: .3,
                length: .3
              }}
            >
          <span>INFORMANTION</span>
          </TransitionLink>
        </MenuElement>
        <MenuElement ref={signupRef}>
          <TransitionLink
            to='/signup'
            style={{ color: '#ffffff' }}
            exit={{
              trigger: ({ entry, node }) => gsap.to(node, { opacity: 0, duration: .3 }),
              length: .3
            }}
            entry={{
              trigger: ({ exit, node }) => gsap.from(node, { opacity: 0, duration: .3 }),
              delay: .3,
              length: .3
            }}
          >
            <span>SIGN UP</span>
            </TransitionLink>
          </MenuElement>
        <MenuElement ref={savedRef} onClick={() => setSavedEventsOpen(!isSavedEventsOpen)}>
          <TextHolder>
            <span>SAVED EVENTS</span>
             <ArrowHolder isOpen={isSavedEventsOpen}>
                <ArrowSvg />
              </ArrowHolder>
          </TextHolder>
          <EventsContainer ref={savedEventsRef}>
            {savedTrips.map(trip => {
              return <SavedEventView
                key={`saved-menu-${trip}`}
                removeActivty={removeActivty}
                {...activities.find(activity => activity.id === trip)}
              />
            })}
          </EventsContainer>
        </MenuElement>
      </MobileMenuView>
      <Background ref={bgRef} className='mainMobileBackground' />
    </>
  )
}
export default MobileMenu
